module.exports = __webpack_public_path__ + "img/35D.97b6749c.png";